import { Component, OnInit } from '@angular/core';
import { HeaderDataService } from '../../services/header_data.service';
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {LockPolicyTableComponent} from "../lock-policy-table/lock-policy-table.component";

@Component({
    selector: 'lock-policy-table-view',
    imports: [
        MatTabGroup,
        MatTab,
        LockPolicyTableComponent
    ],
    templateUrl: './lock-policy-table-view.component.html'
})
export class LockPolicyTableViewComponent implements OnInit {

    constructor(private headerData: HeaderDataService) {
    }

    ngOnInit(): void {
        this.buildHeader();
    }

    buildHeader() {
        this.headerData.title = 'Lock Policy Tables';
        this.headerData.show_dtp = false;
    };
}
